<template>
  <div class="form-row">
    <h6 class="sub-frm-title">Download Events Report</h6>
    <div class="col-sm-12">
      <b-card style="border: 1px dotted #07a7e14f;">
        <div class="row">
            <div class="col-sm-3">
                <selectize
              id="select-training-type"
              v-model="selectedTrainingType"
             @input="fetchTrainingsByType"
             :searchable="true"
              :settings="typeSettings"
            >
              <option
                v-for="(item, index) in trainingTypeList"
                :key="index"
                :value="item.id"
              >
                {{ item.title }}
              </option>
            </selectize>
            </div>
          <div class="col-sm-6">
            <selectize
              id="select-training"
              v-model="selectedTrainings"
              :searchable="true"
              :settings="trainingSettings"
              
            >
              <option
                v-for="(item, index) in trainingListArr"
                :key="index"
                :value="item.id"
              >
                {{ item.title }}
              </option>
            </selectize>
            <!-- <multiselect
                                       v-model="selectedTraining"
                                       :options="trainingListArr"
                                       :custom-label="option => option.title"
                                       track-by="id"
                                       placeholder="Search or Select Event"
                                       :multiple="false"
                                     >
                                     
                                       <template #option="props">
                                         <div class="option-custom">
                                           <strong>{{ props.option.title }}</strong><br />
                                           <small>{{ formatDate3(props.option.startdate) }} to {{ formatDate3(props.option.enddate) }}</small><br />
                                           <small>{{ props.option.venue }}</small>
                                         </div>
                                       </template>
                                     
                                      
                                       <template #singleLabel="props">
                                         <div class="option-custom">
                                           <strong>{{ props.option.title }}</strong><br />
                                          
                                         </div>
                                       </template>
                                     </multiselect> -->
          </div>
          <div class="col-sm-3">
            <!-- add button starts-->
            <b-button
              class="download-btn"
              variant="primary"
              @click="getReport"
              :disabled="selectedTrainings.length === 0"
            >
              Download Sheet
            </b-button>
            <!-- add button ends -->
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Selectize from "vue2-selectize";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { downloadTrainingReport} from '../../utils/DownloadReport';
import { formatDate3 } from "@/utils/DateFormate";


export default {
    data: () => ({
        trainingTypeList: [],
        selectedTrainingType: null,
        trainingListArr: [],
        selectedTrainings: [],
        trainingReport: [],
        training_code: null,
        userId: '',
        userRole: '',
        trainingSettings: {
        maxItems: 10,
        plugins: ["remove_button"],
        placeholder: "Select Events"
      },
      typeSettings: {
        maxItems: 1,
        plugins: ["remove_button"],
        placeholder: "Select Events Type"
      }
    }),
    mounted() {
        this.userId = JSON.parse(localStorage.getItem("currentUser")).id
        this.userRole = JSON.parse(localStorage.getItem("currentUser")).role_id
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')

        this.fetchTrainingTypes();
   
    },
    components: {
        Multiselect,
        Selectize
    },
    methods: {
        formatDate3,
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        customLabel(option) {
            return option.title; // Customize the label displayed in the dropdown
        },
        getReport(){
            this.openLoading();
            setTimeout(() => {
                this.closeLoading();
            }, 2000);
           downloadTrainingReport(this.selectedTrainings)
        },
        fetchTrainingTypes() {
           axios
             .get(process.env.VUE_APP_BASE_PATH + "/trainingtype/get")
             .then((response) => {
               this.trainingTypeList = response.data;
             })
             .catch(() => {
               this.$toasted.global.errorMsg("Failed to load training types");
             });
         },
         fetchTrainingsByType() {
      if (!this.selectedTrainingType) return;

      let url = `${process.env.VUE_APP_BASE_PATH}/trainings/get/all?trainingTypeId=${this.selectedTrainingType}`;

      if (this.userRole === 2) {
        url += `&user_id=${this.userId}`;
      } else if (this.userRole === 3) {
        url += `&po_id=${this.userId}`;
      }

      this.openLoading();
      axios
        .get(url)
        .then((res) => {
          this.trainingListArr = res.data;
          this.selectedTrainings = []; // clear selection
        })
        .catch(() => {
          this.$toasted.global.errorMsg("Failed to load trainings");
        })
        .finally(() => this.closeLoading());
    },
       

    },
    computed: {
        filteredTrainings() {
            if (!this.searchQuery) {
                return this.trainingListArr;
            }
            const searchLower = this.searchQuery.toLowerCase();
            return this.trainingListArr.filter(training => {
                const titleLower = training.title.toLowerCase();
                return titleLower.includes(searchLower);
            });
        }
    },
    watch: {
        selectedTraining(newValue) {
            this.training_code = newValue.id;
        }
    }
};
</script>

<style scoped>
@media (max-width: 768px) {}
</style>
